import { render } from "./AboutHeader.vue?vue&type=template&id=5fc03dfc&scoped=true"
import script from "./AboutHeader.vue?vue&type=script&lang=js"
export * from "./AboutHeader.vue?vue&type=script&lang=js"

import "./AboutHeader.vue?vue&type=style&index=0&id=5fc03dfc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc03dfc"]])

export default __exports__